import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/workAttendanceRest/report/confirmAttendance',
    method: 'post',
    data,
  })
}
